import { persist } from 'zustand/middleware';

import { createStore } from '@store/createStore';

const useSensorsTemperatureStore = createStore(
  persist(
    (set) => ({
      refreshInterval: { label: '15 min', value: 15 * 60 * 1000 },

      actions: {
        setRefreshInterval: (refreshInterval) => set({ refreshInterval }),
      },
    }),
    {
      version: 1,
      name: 'sensors-temperature-filters',
      partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => key !== 'actions')),
    },
  ),
  'sensorsTemperatureStore',
);

export const useSensorsTemperatureStoreActions = () => useSensorsTemperatureStore((state) => state.actions);
export const selectRefreshInterval = () => useSensorsTemperatureStore((state) => state.refreshInterval);
